import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchClientReviews } from '../api';
import { opt } from '../lib/media';

export default function ClientStoryReel() {
  const [shots, setShots] = useState([]);

  useEffect(() => {
    fetchClientReviews({ limit: 200 }).then((d) => {
      const withPics = (Array.isArray(d) ? d : []).filter((r) => r.images?.length);
      const pool = withPics.some((r) => r.featured) ? withPics.filter((r) => r.featured) : withPics;
      setShots(pool.flatMap((r) => r.images.map((u) => ({ u, name: r.name, occasion: r.occasion }))).slice(0, 24));
    }).catch(() => {});
  }, []);

  if (!shots.length) return null;
  let row = shots;
  while (row.length < 8) row = [...row, ...shots];
  const dur = `${Math.max(30, row.length * 5)}s`;

  return (
    <section data-testid="client-story-reel" className="py-20 md:py-24 bg-burgundy-950 overflow-hidden">
      <div className="text-center mb-12 px-6">
        <p className="text-gold tracking-luxe text-xs uppercase mb-3">Worn & Adored</p>
        <h2 className="font-display text-4xl md:text-5xl text-cream">Client Stories</h2>
      </div>
      <div className="reel-mask">
        <div className="reel-track flex gap-4 md:gap-6 w-max" style={{ animationDuration: dur }}>
          {[...row, ...row].map((s, i) => (
            <Link key={i} to="/happy-clients" data-testid={i < row.length ? `reel-tile-${i}` : undefined} aria-hidden={i >= row.length}
              className="relative block w-[200px] md:w-[280px] aspect-[3/4] overflow-hidden group shrink-0">
              <img src={opt(s.u, 600)} alt={`${s.name} in HITÉRA`} loading="lazy" decoding="async" width="280" height="373"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              <div className="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-burgundy-950/90 to-transparent">
                <p className="font-display text-lg text-cream leading-tight">{s.name}</p>
                {s.occasion && <p className="text-[10px] tracking-wideluxe uppercase text-gold">{s.occasion}</p>}
              </div>
            </Link>
          ))}
        </div>
      </div>
      <div className="text-center mt-12">
        <Link to="/review" data-testid="reel-share-link" className="inline-block border border-gold text-gold px-9 py-3.5 text-xs tracking-wideluxe uppercase hover:bg-gold hover:text-burgundy-950 transition-colors">Share Your Story</Link>
      </div>
    </section>
  );
}
